import type { PortalThreadDetail } from '@central/api';
import { color, font } from '@central/ui';
import { Alert } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { statusLabel } from './threadLabels';

/** Where a merged or duplicate conversation continues. */
export function MergedBanner({ d }: { d: PortalThreadDetail }) {
  const to = d.mergedInto ?? d.duplicateOf;
  if (!to) return null;
  return (
    <Alert color="gray">
      {d.mergedInto ? 'This conversation was merged into ' : 'Closed as a duplicate of '}
      <Link to="/messages/$threadId" params={{ threadId: to.id }} search={true}>
        {to.ref}
      </Link>{' '}
      ({to.subject}).
      {d.mergedInto ? ' Continue there.' : ' Follow that conversation for updates.'}
    </Alert>
  );
}

/** The customer's own conversations Rethink linked to this one, one per line. */
export function RelatedList({ d }: { d: PortalThreadDetail }) {
  const related = d.related ?? [];
  if (related.length === 0) return null;
  return (
    <ul
      aria-label="Related conversations"
      style={{
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        fontSize: 13,
      }}
    >
      {related.map((r) => (
        <li key={r.id} style={{ overflowWrap: 'anywhere' }}>
          <Link
            to="/messages/$threadId"
            params={{ threadId: r.id }}
            search={true}
            style={{ fontFamily: font.mono }}
          >
            {r.ref}
          </Link>{' '}
          {r.subject} <span style={{ color: color.textMuted }}>({statusLabel[r.status]})</span>
        </li>
      ))}
    </ul>
  );
}
